"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _DragAndDrop = require("./DragAndDrop");
var _InlineWysiwyg = _interopRequireDefault(require("./InlineWysiwyg"));
var _SectionTitle = _interopRequireDefault(require("./SectionTitle"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CeApprovalStatements = function CeApprovalStatements(_ref) {
  var formProps = _ref.formProps;
  var sections = formProps.values.courseDescription.ceApprovalStatements.sections;
  var setStatements = function setStatements(statements) {
    // Need to deep copy to force formProps.dirty and a re-render
    formProps.setValues(_objectSpread(_objectSpread({}, formProps.values), {}, {
      courseDescription: _objectSpread(_objectSpread({}, formProps.values.courseDescription), {}, {
        ceApprovalStatements: _objectSpread(_objectSpread({}, formProps.values.courseDescription.ceApprovalStatements), {}, {
          sections: statements
        })
      })
    }));
  };
  var onDragEnd = function onDragEnd(result) {
    if (!result.destination || !result.source) {
      return;
    }
    var fromIndex = result.source.index;
    var toIndex = result.destination.index;
    var statements = (0, _DragAndDrop.dndSwap)(sections.map(function (statement) {
      return _objectSpread({}, statement);
    }), fromIndex, toIndex);
    setStatements(statements);
  };
  var onClickAdd = function onClickAdd() {
    var statements = sections.map(function (statement) {
      return _objectSpread({}, statement);
    });
    var highestKey = 0;
    statements.forEach(function (statement) {
      if (statement.key > highestKey) {
        highestKey = statement.key;
      }
    });
    statements.push({
      title: '',
      subtitle: '',
      description: '',
      key: highestKey + 1
    });
    setStatements(statements);
  };
  var onClickDelete = function onClickDelete(key) {
    var statements = sections.filter(function (statement) {
      return statement.key !== key;
    });
    setStatements(statements);
  };
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: _style["default"].fieldset
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _style["default"].fieldsetHeading
  }, "CE Approval Statements"), /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
    name: "ceApprovalStatements",
    placeholder: "CE Approval Statements"
  }), /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "ce-approval-statements"
  }, function (dropProvided, dropSnapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, dropProvided.droppableProps, {
      ref: dropProvided.innerRef,
      className: "mb-3"
    }), dropProvided.placeholder, sections.map(function (statement, index) {
      return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        draggableId: "statement-".concat(statement.key),
        index: index,
        key: "statement-".concat(statement.key)
      }, function (dragProvided, dragSnapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          ref: dragProvided.innerRef
        }, dragProvided.draggableProps, dragProvided.dragHandleProps, {
          className: _style["default"].dragContainer
        }), dragProvided.placeholder, /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndArrows, null), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].dragAndDropContent
        }, /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.ceApprovalStatements.sections[".concat(index, "].title"),
          label: "Title"
        }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.ceApprovalStatements.sections[".concat(index, "].subtitle"),
          label: "Subtitle"
        }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.ceApprovalStatements.sections[".concat(index, "].description"),
          label: "Description"
        })), /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndDeleteButton, {
          onClick: function onClick() {
            return onClickDelete(statement.key);
          }
        }));
      });
    }), /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndAddButton, {
      onClick: onClickAdd
    }));
  })));
};
var _default = exports["default"] = CeApprovalStatements;